import LiquidityPools from '@/components/liquidity-pools'
import { MainLayout } from '@/layouts/MainLayout'
import gssp from '@/utils/gssp'

const LiquidityPoolsPage = () => {
  return (
    <MainLayout>
      <LiquidityPools />
    </MainLayout>
  )
}

export const getServerSideProps = gssp()

export default LiquidityPoolsPage
